/*
  Vuex store module for managing all API endpoints
    if a URL base is used more than once it should be added here
 */

export default {
  state: {},
  getters: {
    currentUserApiPrefix(_, getters) {
      return getters.currentUserIsDispatcher
        ? import.meta.env.VITE_DISPATCHER_API_PREFIX
        : getters.currentUserIsImageViewer
          ? import.meta.env.VITE_IMAGE_VIEWER_API_PREFIX
          : getters.currentUserIsOwner
            ? import.meta.env.VITE_OWNER_API_PREFIX
            : getters.currentUserIsConsumer
              ? import.meta.env.VITE_CONSUMER_API_PREFIX
              : 'none';
    },

    baseUrl(_, getters) {
      // if this gets used in the events screens, the api that it points to needs to have the events in the org api
      return `/${getters.currentUserApiPrefix}/${getters.currentUserOrgType}s`;
    },

    baseUrlOrg(_, getters) {
      return `${getters.baseUrl}/${getters.currentUserOrgId}`;
    },

    baseUrlConsumerOrg(_, getters) {
      // Consumer API for either owner or consumer
      return `/${import.meta.env.VITE_CONSUMER_API_PREFIX}/consumers/${getters.currentUserOrgId}`;
    },

    baseUrlMediaOrg(_, getters) {
      return `/${import.meta.env.VITE_MEDIA_API_PREFIX}/${getters.currentUserOrgType}s/${getters.currentUserOrgId}`;
    },

    // *********************************************************************************************************
    // This section of the store is for url's that have the same construction for the owner and consumer,
    // but hit their respective owner/consumer api's
    // *********************************************************************************************************
    accountsEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/accounts`;
    },

    configEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/config`;
    },

    connectionsEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/connections`;
    },

    devicesEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/devices`;
    },

    dispatchesEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/dispatches`;
    },

    eventsEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/events`;
    },

    exportsEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/exports`;
    },

    filesEndpoint(_, getters) {
      return `${getters.baseUrlMediaOrg}/files`;
    },

    instructionsEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/instructions`;
    },

    liveImagesEndpoint: (_, getters) => (ownerId) => {
      if (getters.currentUserIsOwner) {
        return `${getters.baseUrlOrg}/devices`;
      } else {
        return `${getters.baseUrlOrg}/owners/${ownerId}/devices`;
      }
    },

    pairingCodeEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/pairingcode`;
    },

    webBotEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/webbot`;
    },

    summaryEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/summary`;
    },

    // *********************************************************************************************************
    // consumer portal consumer api ONLY endpoints
    // *********************************************************************************************************
    backendSubscriberEndpoint(_, getters) {
      if (!getters.currentUserIsConsumer) {
        throw new Error('backendSubscriberEndpoint retrieved when user is not a consumer');
      }
      return `${getters.baseUrlConsumerOrg}/backendsubscriber`;
    },

    proxyEndpoint(_, getters) {
      if (!getters.currentUserIsConsumer) {
        throw new Error('proxyEndpoint retrieved when user is not a consumer');
      }
      return `${getters.baseUrlConsumerOrg}/proxy`;
    },

    ssoConfigEndpoint(_, getters) {
      if (!getters.currentUserIsConsumer) {
        throw new Error('ssoConfigEndpoint retrieved when user is not a consumer');
      }
      return `${getters.baseUrlConsumerOrg}/sso`;
    },

    // *********************************************************************************************************
    // consumer/owner portal endpoints that both use the consumer api
    // *********************************************************************************************************
    exportsApprovalEndpoint(_, getters) {
      return `${getters.baseUrlConsumerOrg}/exports`;
    },

    subscribersEndpoint(_, getters) {
      return `${getters.baseUrlOrg}/appsubscribers`;
    },

    qrCodeEndpoint(_, getters) {
      return `${getters.baseUrlConsumerOrg}/generateQrCode`;
    },
    scenariosEndpoint(_, getters) {
      return `${getters.baseUrlConsumerOrg}/scenarios`;
    },
    templatesEndpoint(_, getters) {
      return `${getters.baseUrlConsumerOrg}/templates`;
    },
  },
};
